export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20product%20photography%20scene%20with%20carefully%20arranged%20fashion%20items%20including%20sneakers%20folded%20knitwear%20and%20accessories%20on%20light%20cream%20wooden%20table%20surface%20soft%20golden%20hour%20sunlight%20streaming%20from%20window%20creating%20gentle%20warm%20highlights%20clean%20aesthetic%20editorial%20style%20warm%20beige%20and%20sandy%20tones%20throughout%20peaceful%20atmosphere%20high%20end%20product%20display%20composition%20no%20people&width=1800&height=1200&seq=yoybuy-hero-v2-01&orientation=landscape"
        alt="Yoybuy Spreadsheet product showcase"
        title="Yoybuy Spreadsheet shopping system"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/20 to-black/10"></div>

      <div className="relative z-10 flex h-full w-full">
        <div className="flex flex-col justify-center w-full max-w-[1400px] mx-auto px-8 md:px-16">
          <span className="text-xs tracking-[0.3em] uppercase text-white/60 font-label mb-6">
            / Yoybuy Sheet
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-light text-white leading-[1.3] max-w-[680px] mb-4"
            style={{ fontFamily: 'var(--font-heading)' }}>
            Yoybuy Spreadsheet —<br />самый простой способ<br />покупать товары из Китая
          </h1>

          <p className="text-base md:text-lg text-white/70 font-light max-w-[520px] mb-10 leading-relaxed">
            Покупайте с Taobao, 1688 и китайских магазинов через удобную систему таблиц.
            Без сложных форм. Без ошибок. Без переплат.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3 mb-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap px-8 py-3.5 rounded-full bg-foreground-950 text-white font-label text-sm font-medium hover:bg-foreground-800 transition-all duration-300 cursor-pointer"
            >
              Yoybuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap px-8 py-3.5 rounded-full border border-white/60 text-white font-label text-sm font-medium hover:bg-white/10 transition-all duration-300 cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-xs text-white/50 font-label">• 100,000+ заказов</span>
            <div className="flex -space-x-2">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="w-9 h-9 rounded-full bg-background-200/60 border-2 border-white/20 overflow-hidden">
                  <div className="w-full h-full bg-gradient-to-br from-background-100 to-secondary-200"></div>
                </div>
              ))}
            </div>
            <span className="text-xs text-white/50 font-label ml-1">Доверие покупателей</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/40 text-2xl"></i>
      </div>
    </section>
  );
}